export default {
  nav: {
    home: 'Home',
    equipment: 'Products',
    equipmentSingle: 'Single-Wire Equipment',
    equipmentSingleDesc: 'High-precision metal 3D printing',
    equipmentMulti: 'Multi-Beam Equipment',
    equipmentMultiDesc: '5x+ efficiency boost',
    equipmentTitanium: 'Sponge Titanium',
    equipmentTitaniumDesc: 'Low-cost titanium printing',
    services: 'Services',
    lattice: 'Lattice Structures',
    latticeDesc: '70% weight reduction',
    concrete: 'Steel Lattice Concrete',
    concreteDesc: '3x strength boost',
    titaniumAlloy: 'Ultra-Low-Cost Titanium',
    titaniumAlloyDesc: '50% cost reduction',
    solutions: 'Solutions',
    ship: 'Ship Lightweighting',
    shipDesc: '70% weight reduction',
    platform: 'Offshore Floating Platforms',
    platformDesc: '50% cost reduction',
    deepSea: 'Deep-Sea Pressure Hulls',
    deepSeaDesc: '6000m depth',
    news: 'News',
    about: 'About',
    quote: 'Quote',
    menu: 'Menu'
  },
  footer: {
    desc: 'A leading metal additive manufacturing solution provider, committed to innovative lightweight technologies for ocean engineering.',
    wechat: 'WeChat',
    weibo: 'Weibo',
    qrPending: 'QR code pending (upload in Admin > About > Company Info)',
    xiaohongshu: 'Xiaohongshu',
    products: 'Products & Services',
    solutions: 'Solutions',
    about: 'About Us',
    intro: 'Company Profile',
    news: 'News',
    contact: 'Contact Us',
    join: 'Careers',
    contactTitle: 'Contact',
    address: '📍 Nanshan Science Park, Shenzhen, Guangdong',
    phone: '📞 400-888-8888',
    email: "📧 info{'@'}megamaker.com.cn",
    hours: '🕐 Mon-Fri 9:00-18:00',
    copyright: '© 2026 MegaMaker. All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    sitemap: 'Sitemap',
    mapPending: 'Map address is not configured. Please ask the admin to fill it in System Config.',
    gotIt: 'Got it'
  },
  legal: {
    privacy: [
      'We value and protect your privacy. This Privacy Policy explains how the MegaMaker website (the "Site") collects, uses, stores and protects your personal information.',
      '1. Information We Collect: information you voluntarily submit (such as name, phone, email, company and inquiry content via the online inquiry form); and browsing records, IP addresses, device information and cookie data generated when you use the Site.',
      '2. How We Use Information: to respond to your inquiries and needs, improve the Site content and our products and services, send business materials you have requested, and for other purposes required or authorized by law.',
      '3. Information Sharing: we do not sell or rent your personal information to any third party. We may only disclose it with your explicit consent, when required by laws or government authorities, or as necessary to perform services for you (e.g. contracted logistics or technical providers, all bound by confidentiality agreements).',
      '4. Cookies and Statistics: the Site may use cookies to improve your browsing experience and collect anonymous statistics. You can disable cookies in your browser settings without affecting basic browsing.',
      '5. Data Security: we apply reasonable technical and administrative measures (such as encrypted transmission and access control) to protect your information from unauthorized access, disclosure or damage.',
      '6. Your Rights: you have the right to access, correct or delete your personal information, withdraw consent or request deletion of related records. To exercise these rights, please contact us via the "Contact Us" channel or the contact details in the footer.',
      '7. Minors: the Site mainly serves corporate customers and does not proactively collect personal information of minors.',
      '8. Policy Updates: this policy may be revised from time to time; updates will be published on this page. Continued use of the Site constitutes acceptance of the updated policy.'
    ],
    terms: [
      'Welcome to the MegaMaker website. Please read these Terms of Use carefully before using the Site. By accessing or using the Site, you agree to be bound by these terms.',
      '1. Site Content: the products, technologies, images, text and data on this Site are protected by copyright and applicable laws and are owned by MegaMaker or their respective right holders. No reproduction, distribution, modification or commercial use is permitted without prior written consent.',
      '2. Restrictions: you must not use the Site for any unlawful activity, attempt to undermine the security or normal operation of the Site, or infringe the lawful rights of others in any way.',
      '3. Accuracy of Information: we strive to keep the Site content accurate and complete, but do not guarantee its real-time accuracy or completeness. Product specifications and performance shall be subject to the contract and technical documents signed by both parties.',
      '4. Disclaimer: to the extent permitted by law, we shall not be liable for any direct or indirect loss arising from the use of or reliance on the information on this Site. Links to third-party websites are provided for convenience only; their content is the responsibility of the third parties.',
      '5. IP Infringement Complaints: if you believe content on this Site infringes your intellectual property rights, please contact us with proof of ownership and a description of the infringement; we will handle it in accordance with the law after verification.',
      '6. Changes to Terms: we may revise these terms from time to time; revisions take effect once published on this page.',
      '7. Governing Law: these terms are governed by the laws of the People\'s Republic of China. Any dispute arising from the Site shall be resolved through friendly negotiation; if negotiation fails, the dispute shall be submitted to the competent court where the company is located.'
    ]
  },
  common: {
    viewDetail: 'View Cases',
    learnMore: 'Learn More',
    loading: 'Loading...'
  },
  inquiry: {
    title: 'Online Inquiry',
    subtitle: 'Leave your requirements and our expert team will contact you within 1 business day',
    name: 'Your Name',
    phone: 'Phone',
    company: 'Company',
    subject: 'Subject',
    content: 'Message',
    submit: 'Submit Inquiry',
    submitting: 'Submitting...',
    success: 'Submitted successfully, we will contact you soon',
    fail: 'Submission failed, please try again later'
  },
  video: {
    comingSoon: 'Video coming soon'
  },
  maintenance: {
    title: 'Under Maintenance',
    desc: 'We are currently performing system upgrades. Sorry for the inconvenience, please try again later.',
    tip: 'Contact us for urgent needs'
  },
  error: {
    title: 'Failed to Load Data',
    desc: 'Unable to reach the server. Please check your connection or try again later',
    retry: 'Retry'
  },
  home: {
    exploreProducts: 'Explore Products',
    contactUs: 'Contact Us',
    videoComingSoon: 'Corporate video coming soon',
    intoTitle: 'Inside MegaMaker',
    intoDesc: 'Explore our smart manufacturing base and see how metal additive manufacturing equipment drives industrial upgrade',
    bookTour: 'Book a Visit',
    coreEquipment: 'Core Equipment',
    equipTitle: 'Industry-Leading 3D Printing Technology',
    learnMoreArrow: 'Learn More →',
    solutions: 'Solutions',
    solutionsTitle: 'Tailored for Ocean Engineering',
    viewCases: 'View Cases →',
    aboutLabel: 'About Us',
    introTitleLine1: 'Break Traditional Manufacturing Boundaries',
    introTitleLine2: 'Usher in a New Era of Ocean Engineering',
    introText: 'MegaMaker specializes in large-scale metal 3D printing, holding core patents in single-wire, multi-beam and sponge titanium technologies. Our technology achieves 70% weight reduction and 50% cost reduction, delivering revolutionary solutions for ocean engineering.',
    mediaBadge: 'Smart Manufacturing Base',
    labAlt: 'Laboratory',
    ctaTitle: 'Ready to Start Your Project?',
    ctaDesc: 'Contact our expert team for professional technical consultation and customized solutions',
    quote: 'Get a Quote',
    bookConsult: 'Book a Consultation'
  }
,
  eq: {
    title: 'Core Equipment',
    subtitle: 'Leading Metal 3D Printing Technology',
    t1: 'Single-Wire Technology',
    t1n: 'Single-Wire Equipment',
    t1f1: '✓ Precision: ±0.1mm',
    t1f2: '✓ Materials: stainless steel, titanium, aluminum',
    t1f3: '✓ Build size: 500×500×500mm',
    t1f4: '✓ Speed: 100-200g/h',
    t2: 'Multi-Beam Technology',
    t2n: 'Multi-Beam Equipment',
    t2f1: '✓ Efficiency: 5x+ boost',
    t2f2: '✓ Max size: 2000×2000×1000mm',
    t2f3: '✓ Laser beams: 4-8 optional',
    t2f4: '✓ Sync precision: ±0.05mm',
    t3: 'Sponge Titanium Technology',
    t3n: 'Sponge Titanium Equipment',
    t3f1: '✓ Cost reduction: 50%+',
    t3f2: '✓ Corrosion resistance: marine-grade',
    t3f3: '✓ Material utilization: 95%+',
    t3f4: '✓ ISO 14001 certified',
  }
,
  svc: {
    title: '3D Printing Services',
    subtitle: 'Professional Metal Additive Manufacturing Solutions',
    l1: 'Lattice Structures',
    l1b: '70% Weight Reduction',
    l1f1: 'Weight reduced by 70%+',
    l1f2: '90% strength retention',
    l1f3: '60% material savings',
    l1f4: 'Custom designs',
    l2: 'Steel Lattice Concrete',
    l2b: '3x Strength Boost',
    l2f1: '3x compressive strength',
    l2f2: 'Superior corrosion resistance',
    l2f3: '50% shorter construction time',
    l2f4: 'Extended service life',
    l3: 'Ultra-Low-Cost Titanium',
    l3b: '50% Cost Reduction',
    l3f1: '50% cost reduction',
    l3f2: 'Performance rivaling conventional titanium',
    l3f3: 'Marine-environment ready',
    l3f4: 'Fast delivery',
  }
,
  sol: {
    title: 'Solutions',
    subtitle: 'Innovative Lightweighting Solutions for Ocean Engineering',
    s1: 'Ship Lightweighting',
    s1b: '70% Weight Reduction',
    s1f1: '70% weight reduction',
    s1f2: '30% fuel savings',
    s1f3: 'Higher cargo capacity',
    s1f4: 'High corrosion resistance',
    s2: 'Low-Cost Offshore Platforms',
    s2b: '50% Cost Reduction',
    s2f1: 'Shorter construction time',
    s2f2: 'High wave resistance',
    s2f3: 'Eco-friendly & sustainable',
    s3: 'Low-Cost Deep-Sea Hulls',
    s3b: '6000m Depth',
    s3f1: 'Withstands 6000m depth',
    s3f2: 'Titanium alloy',
    s3f3: 'Greatly reduced cost',
    s3f4: 'Custom designs',
  }
,
  news: {
    learnMore: 'Learn More',
    latest: 'Latest News',
    readMore: 'Read More',
    preview: 'News Preview',
    mediaResource: 'Media Resource',
    all: 'All',
    corp: 'Company News',
    product: 'Product News',
    exhibition: 'Exhibitions',
    imageDownload: 'Image Downloads',
    videoDownload: 'Video Downloads',
    m1: 'New Ultra-Integrated Laser Wire-Feed AM System L1 Lite',
    m2: 'Desktop Metal 3D Printer Laser Mini',
    m3: 'Coaxial 5000W Laser Flow Control',
    m4: 'Laser Wire-Feed AM Technology Advantages',
    m5: 'Rongsu Tech Wins Industry Innovation Award',
    m6: 'China Welding Association Technical Exchange',
    defaultCategory: 'Industry News',
    backToList: 'Back to News List',
  }
,
  about: {
    titleLine1: 'About',
    titleLine2: 'MegaMaker',
    subtitle: 'Leading Metal Additive Manufacturing Solutions Provider',
    intro: 'Company Profile',
    history: 'Milestones',
    honors: 'Certifications & Honors',
    contact: 'Contact Us',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    follow: 'Follow Us',
    followDesc: 'Get the latest product news and technical support',
    projectNeed: 'Have a Project in Mind?',
    projectDesc: 'Leave your requirements and our expert team will contact you within 1 business day',
    inquiryNow: 'Inquire Now',
    introFallback: 'MegaMaker, dedicated to the R&D and application of metal additive manufacturing technology.',
  }
,
  eqd: {
    brand: 'MegaMaker',
    metalAdditive: 'Metal Additive Manufacturing',
    viewCount: 'Views',
    minLayer: 'Min Layer (mm)',
    materials: 'Materials',
    consultNow: 'Inquire Now',
    moreEquipment: 'More Equipment',
    priceRange: 'Price',
    negotiate: 'Negotiable',
    onSale: 'On Sale',
    pending: 'On Request',
    coreParams: 'Core Parameters',
    gallery: 'Gallery',
    galleryDesc: 'See the equipment from every angle',
    demo: 'Equipment Demo',
    demoDesc: 'Watch the equipment in action',
    features: 'Key Features',
    featuresDesc: 'Technical capabilities built for high-performance metal AM',
    featureDefault: 'Professional performance guarantee',
    specs: 'Specifications',
    ctaTitle: 'Ready to upgrade your project with additive manufacturing?',
    ctaDesc: 'Contact our expert team for a detailed proposal and quote for {name}',
    ctaBtn: 'Get a Quote Now',
    videoPlaceholder: 'Equipment demo video coming soon',
  }
,
  svd: {
    priceInfo: 'Pricing',
    quote: 'Project-based quote',
    standardFlow: 'Standard Process',
    steps: 'steps',
    proService: 'MegaMaker · Professional Services',
    process: 'Service Steps',
    highlights: 'Highlights',
    viewCount: 'Views',
    consultNow: 'Inquire Now',
    viewCases: 'View Cases',
    flowTitle: 'Service Process',
    flowDesc: 'Standardized process for guaranteed delivery quality',
    teamDesc: 'A professional team at your service',
    scenes: 'Service Scenes',
    scenesDesc: 'Full-process showcase from process to results',
    sceneTags: ['Core Process', 'Production', 'Quality Inspection'],
    sceneDefault: 'Service Scene',
    videoTitle: 'Service Case Video',
    videoDesc: 'Documentary of real service projects',
    featureDefault: 'Professional capability',
    detail: 'Service Details',
    params: 'Service Parameters',
    ctaTitle: 'Need {title} service?',
    ctaDesc: 'Contact our expert team for professional proposals and quotes',
    ctaBtn: 'Get a Quote Now',
    videoPlaceholder: 'Service case video coming soon',
  }
,
  sld: {
    industry: 'Industry Solution',
    advantages: 'Advantages',
    advantagesTitle: 'Advantages',
    cases: 'Cases',
    viewCount: 'Views',
    getSolution: 'Get Solution',
    learnEquipment: 'Explore Equipment',
    online: 'Live',
    custom: 'On Customization',
    pain: 'Pain Points · Advantages',
    painDesc: 'Address industry pain points with implementable solutions',
    painTitle: 'Industry Pain Points',
    casesDesc: 'How the solution is applied in real projects',
    caseTags: ['Overview', 'Industry Application', 'Engineering'],
    caseDefault: 'Typical Application',
    detail: 'Solution Details',
    videoTitle: 'Solution Case Video',
    videoDesc: 'See how the solution performs in real projects',
    ctaTitle: 'Want to see how {title} can be implemented?',
    ctaDesc: 'Talk to our solution experts for customized implementation advice',
    ctaBtn: 'Get a Custom Solution',
    videoPlaceholder: 'Solution case video coming soon',
  }
}
